var map = {
	"./Group 22302.png": 1310,
	"./avatar-christmas.webp": 1311,
	"./bottom-bg-christmas.webp": 1312,
	"./btn-active.png": 1313,
	"./content-deco-1.webp": 1314,
	"./content-deco-2.webp": 1315,
	"./content-deco-3.webp": 1316,
	"./content-deco-4.webp": 1317,
	"./deco-3.webp": 1318,
	"./deposit-icon.webp": 1319,
	"./home-icon-active.webp": 1320,
	"./home-icon.webp": 1321,
	"./live-icon-active.webp": 1322,
	"./live-icon.webp": 1323,
	"./master-bg.jpg": 1324,
	"./me-icon-active.webp": 1325,
	"./me-icon.webp": 1326,
	"./platform.png": 1327,
	"./platform.webp": 1328,
	"./promos-icon-active.webp": 1329,
	"./promos-icon.webp": 1330,
	"./promos.webp": 1331,
	"./service-christmas.webp": 1332,
	"./snowman.webp": 1333,
	"./sponsor-icon-active.webp": 1334,
	"./sponsor-icon.webp": 1335,
	"./title-deco-left.webp": 1336,
	"./title-deco-right.webp": 1337,
	"./tree.webp": 1338,
	"./vip-icon.webp": 1339,
	"./vip.webp": 1340,
	"./withdraw-icon.webp": 1341,
	"./wwr-img.webp": 1342
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 122;